import { Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { TableColumn } from '@app/components/common/table';
import { CategorySku } from '@app/api/models/sku';

export const useColumns = ({
  onEdit,
}: {
  onEdit: (category: CategorySku) => void;
}) => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'name',
      label: 'Название',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'is_active',
      label: 'Активна',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: boolean) => <span>{value ? 'Да' : 'Нет'}</span>,
      },
    },
    {
      name: 'id',
      label: 'Действия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (id, { rowData }) => {
          return (
            <Flex gap={2}>
              <IconButton
                name="edit"
                onClick={() => onEdit(rowData as CategorySku)}
                aria-label="edit"
              >
                <MdEdit />
              </IconButton>
            </Flex>
          );
        },
      },
    },
  ] as TableColumn<CategorySku>[];
};
